import {
  CardMedia,
  Card,
  CardContent,
  CardActionArea,
  Typography,
  useTheme,
  Fade,
  Button,
  Checkbox,
} from "@mui/material";
import { TrashIcon } from "~components/Icons/index";
import { LazyLoadComponent } from "react-lazy-load-image-component";
import { getStyles } from "./styles";

const LazyLoadComponentAny = LazyLoadComponent as any;

interface ProductCardProps {
  productImage: string;
  productName: string;
  productPrice: string;
  type?: "default" | "delete" | "select";
  imageType?: "default" | "realtimeProduct";
  onClick?: (e?: React.MouseEvent) => void;
  isDisabled?: boolean;
  isChecked?: boolean;
  productId?: string | number;
  providerId?: string | number;
}

const ProductCard = (props: ProductCardProps) => {
  const {
    productImage,
    productName,
    productPrice,
    type = "default",
    imageType = "default",
    onClick,
    isDisabled,
    isChecked,
    productId,
    providerId,
  } = props;
  const theme: any = useTheme();
  const { styles } = getStyles(theme, isDisabled);

  return (
    <Card variant="cardList" data-product-id={productId} data-provider-id={providerId}>
      <>
        {type === "delete" && (
          <Button
            variant="roundButton"
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onClick?.(e);
            }}
            sx={styles.deleteButton}
            type="button"
          >
            {<TrashIcon sx={styles.trashIcon} />}
          </Button>
        )}

        {type === "select" && !isDisabled && (
          <Checkbox
            sx={styles.checkBox}
            onClick={() => onClick && onClick()}
            checked={!!isChecked}
            disableRipple
          />
        )}

        {LazyLoadComponentAny && (
          <LazyLoadComponentAny>
            <Fade in={true} timeout={1000}>
              <CardActionArea
                disableRipple
                sx={styles.cardClick}
                onClick={() => {
                  if (type === "select" && onClick && !isDisabled) {
                    onClick();
                  }
                }}
              >
                <CardMedia
                  sx={
                    imageType === "realtimeProduct"
                      ? styles.cardMediaRealtime
                      : styles.cardMediaDefault
                  }
                  component="img"
                  image={productImage}
                />
              </CardActionArea>
            </Fade>
          </LazyLoadComponentAny>
        )}
        <CardContent sx={styles.cardContent}>
          <Typography component="div" variant="overline" sx={styles.nameTypography}>
            {productName}
          </Typography>
          <Typography component="div" variant="overline" sx={styles.priceTypography}>
            {productPrice}
          </Typography>
        </CardContent>
      </>
    </Card>
  );
};

export default ProductCard;
